import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "./CustomerSelectField.module.scss";
import { useCustomerSelectField } from "./useCustomerSelectField";

const CustomerSelectField = ({
  value = "",
  label = null,
  isRequired = false,
  placeholder = "Search customer by name or phone number",
  errorMessage = undefined,
  floatError = true,
  classNames = "",
  onChange = () => {},
  onControllerChange = () => {},
}) => {
  const {
    containerRef,
    inputValue,
    isDropdownOpen,
    isLoading,
    customers,
    handleInputChange,
    handleSelect,
    handleFocus,
  } = useCustomerSelectField({ value });

  return (
    <div
      className={`${styles.customerSelectField} ${classNames}`}
      ref={containerRef}
    >
      {label !== null && (
        <label>
          {isRequired && <span className="text-danger">*</span>}
          <span>{label}</span>
        </label>
      )}

      <div className={styles.inputWrapper}>
        <input
          type="text"
          className={`${styles.searchInput} ${errorMessage !== undefined ? styles.error : ""} ${classNames === "white" ? styles.white : ""}`}
          value={inputValue}
          placeholder={placeholder}
          onChange={(e) => handleInputChange(e.target.value)}
          onFocus={handleFocus}
          autoComplete="off"
        />
        {isLoading && (
          <span className={styles.spinner}>
            <FontAwesomeIcon icon={["fas", "spinner"]} className="fa-spin" />
          </span>
        )}
      </div>

      {isDropdownOpen && (
        <div className={styles.dropdown}>
          {isLoading ? (
            <p className={styles.loadingState}>Searching customers...</p>
          ) : customers.length > 0 ? (
            customers.map((customer) => (
              <div
                key={customer.id}
                className={styles.dropdownItem}
                onClick={() =>
                  handleSelect(customer, onControllerChange, onChange)
                }
              >
                <span className={styles.name}>{customer?.full_name || ""}</span>
                <span className={styles.phone}>{customer?.phone || ""}</span>
              </div>
            ))
          ) : (
            <p className={styles.emptyState}>No customers found</p>
          )}
        </div>
      )}

      {(floatError ||
        (errorMessage !== undefined && errorMessage?.message)) && (
        <p
          className={`error-message text-danger ${errorMessage !== undefined ? "show" : ""}`}
          data-testid="error-message"
        >
          <FontAwesomeIcon
            icon={["fas", "exclamation-circle"]}
            className="mr-2"
            style={{ fontSize: "13px" }}
          />
          {errorMessage !== undefined && <span>{errorMessage?.message}</span>}
        </p>
      )}
    </div>
  );
};

export default CustomerSelectField;
